module.exports = __webpack_public_path__ + "static/media/gr6-newsletter-2.2d8752ee.pdf";